import { createAsyncThunk } from "@reduxjs/toolkit";
import { CommonAxiosResponse, thunkResponseHandler } from "common";
import {
  CartProductResponse,
  EligibleVoucherPayload,
  EligibleVoucherResponse,
  VoucherValidationPayload,
} from "./types";
import { VoucherApi } from "./api";
import { store } from "app/createStore";

export const getValidateVoucherThunk = createAsyncThunk<
  CommonAxiosResponse<CartProductResponse>,
  VoucherValidationPayload
>("Voucher/getValidateVoucherThunk ", async (data) => {
  const cart = store?.getState()?.Cart?.cart?.map((cart_item) => ({
    cart_id: cart_item?.cart_id,
    product_name: cart_item?.product_name,
    product_uuid: cart_item?.product_uuid,
    product_slug: cart_item?.product_slug,
    amount: cart_item?.amount,
    category_id: cart_item?.category_id,
  }));

  const params = {
    products: cart,
    total_amount: data?.total_amount,
    voucher_code: data?.voucher_code,
  };
  const res = await VoucherApi.getValidVoucher(params);
  const toThunk = thunkResponseHandler(res);
  return toThunk;
});

export const getEligibleVoucherListThunk = createAsyncThunk<
  CommonAxiosResponse<EligibleVoucherResponse>,
  EligibleVoucherPayload
>("Voucher/getEligibleVoucherListThunk ", async (data) => {
  const cart = store?.getState()?.Cart?.cart?.map((cart_item) => ({
    cart_id: cart_item?.cart_id,
    product_name: cart_item?.product_name,
    product_uuid: cart_item?.product_uuid,
    product_slug: cart_item?.product_slug,
    amount: cart_item?.amount,
    category_id: cart_item?.category_id,
  }));

  const params = { products: cart, total_amount: data?.total_amount };
  const res = await VoucherApi.getEligibleVoucher(params);
  const toThunk = thunkResponseHandler(res);
  return toThunk;
});
